// extracted by mini-css-extract-plugin
export default {"container":"container_Ict3X","title":"title_H5c9p"};